// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MacCommandFilledSvg from "@fishx/icons-svg/es/asn/MacCommandFilled";
import FishxIcon from '../components/FishxIcon';

var MacCommandFilled = function MacCommandFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandFilledSvg
  }));
};

MacCommandFilled.displayName = 'MacCommandFilled';
export default React.forwardRef(MacCommandFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MacCommandFilled.js
// module id = 3075
// module chunks = 0